import { IconKey } from '../../assets';
import { ModuleSlug, NodeModel } from '../../types';

export function buildNodeWithUnits(
  props: Omit<NodeModel, 'children' | 'centerOffset' | 'icon' | 'label'> & {
    moduleSlug: ModuleSlug;
    icon: IconKey;
    label: string;
  },
): NodeModel {
  const labelLine1 = props.label.replace(/\n/g, ' ');
  return {
    ...props,
    tag: props.moduleSlug,
    moduleSlug: undefined,
    layout: 'horizontal',
    children: [
      {
        moduleSlug: props.moduleSlug,
        moduleVariant: 1,
        icon: 'unit-systems/metric',
        label: {
          aria: `${labelLine1} - Metric`,
        },
        filtered: {
          icon: props.icon,
          label: `${labelLine1}\nMetric`,
        },
      },
      {
        moduleSlug: props.moduleSlug,
        moduleVariant: 2,
        icon: 'unit-systems/mixed',
        label: {
          aria: `${labelLine1} - Mixed`,
        },
        filtered: {
          icon: props.icon,
          label: `${labelLine1}\nMixed`,
        },
      },
      {
        moduleSlug: props.moduleSlug,
        moduleVariant: 0,
        icon: 'unit-systems/us',
        label: {
          aria: `${labelLine1} - US Customary`,
        },
        filtered: {
          icon: props.icon,
          label: `${labelLine1}\nUS Customary`,
        },
      },
    ],
  };
}
